export type CloudinaryAsset = {
  public_id: string;
  secure_url: string;
  format: string;
  width: number;
  height: number;
  resource_type: string;
};

export interface CloudinaryFolder {
  name: string;
  path: string;
  files_count: number;
}

export interface AppFile {
  id: string;
  name: string;
  type: string;
  url: string;
  size: string | number;
  dateAdded: Date;
}

// Add a type for serialized files (used in caching)
export interface SerializedAppFile {
  id: string;
  name: string;
  type: string;
  url: string;
  size: string | number;
  dateAdded: string;
}

export const MediaSortOptions = ["name", "date"];

export interface CloudinaryFile {
  public_id: string;
  format: string;
  secure_url: string;
  bytes: number;
  created_at: string;
  uploaded_at?: string; // When the file was uploaded (might not always be present)
  resource_type: string;
  type: string;
  width: number;
  height: number;
}

// Add file type definitions with their extensions
export const FILE_TYPES = {
  images: {
    id: "images",
    label: "Images",
    extensions: ["jpg", "jpeg", "png", "webp", "gif", "svg"],
  },
  videos: {
    id: "videos",
    label: "Videos",
    extensions: ["mp4", "mkv", "mov", "avi", "webm"],
  },
  documents: {
    id: "documents",
    label: "Documents",
    extensions: [
      // Microsoft Office
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      // Adobe
      "pdf",
      "psd",
      "ai",
      "indd",
      "eps",
      // Other documents
      "txt",
      "rtf",
    ],
  },
} as const;
